/**
 * @generated SignedSource<<444e8e37f8d920189bb624c99cdc7e06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueTypePickerIssueType$data = {
  readonly description: string | null;
  readonly id: string;
  readonly isEnabled: boolean;
  readonly name: string;
  readonly " $fragmentType": "IssueTypePickerIssueType";
};
export type IssueTypePickerIssueType$key = {
  readonly " $data"?: IssueTypePickerIssueType$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypePickerIssueType">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueTypePickerIssueType"
};

(node as any).hash = "40fbe73c45b53ba4acb5d2b67ce97e1b";

export default node;
